import React from 'react';
import PageNavigation from '../Tienda/components/Navigation/Pagination';
import ProductosHeader from '../Tienda/views/Productos/Header/ProductosHeader';
import ProductosFilter from './Filter/ProductosFilter';
import { View } from "../TiendaConfig";
import Loader from 'react-loader-spinner';


const BannerOfertas = ({ showBanner, bannerSrc }) => showBanner && bannerSrc && (
  <div className="row col-12 mt-2 mx-auto">
    <img alt="banner oferta" className="rounded d-block mx-auto imagebanner" src={bannerSrc} />
  </div>
);

const ProductosView = (props) => {
  const {
    filters, productos, breadcrumbs, loading, reloading,
    chosenPage, totalPages, search, onChangeSearch, onChangeFilter, removeCodesFromUrl,
    onShowMore, OnChangeNavigationBar, showBanner, bannerSrc, totalProductos
  } = props;

  const showFilters = props.showFilter && filters && filters.length > 0;

  return (loading || reloading) && filters.length == 0 ? (
    <div className="text-center">
      <Loader
        type="Bars"
        color="#00BFFF"
        height={100}
        width={100}
        timeout={3000} //3 secs
      />
    </div>
  ) : (
    <>
      <BannerOfertas {...{ showBanner, bannerSrc }} />
      <div className="esige-productos">
        {
          totalProductos == 0 ? (
            <div className="text-center py-5">
              <h2>No hay productos para mostrar</h2>
            </div>
          ) : (
            <>
              <ProductosHeader
                loading={loading || reloading}
                breadcrumbs={breadcrumbs}
                sort={search.get('sort')}
                pageSize={search.has('pageSize') ? search.get('pageSize') : 24}
                onChangeSearch={(value, key) => onChangeSearch(value, key)}
              />
              <div className="esige-productos-container px-md-4 px-md-0 pr-md-3 mb-2">
                <div className="d-none d-lg-flex offset-lg-3 col-lg-9">
                  <div className="alert alert-success alert-price">* Los precios publicados son de lista y se pueden pagar en 6 cuotas fijas con tarjeta sin interés. Consulte descuentos de contado.</div>
                  <p className="my-auto ml-auto text-right"><small><strong>{totalProductos}</strong> productos encontrados</small></p>
                </div>

                <div className="d-block d-lg-none col-12">
                  <div className="mt-1 alert alert-success alert-price">* Los precios publicados son de lista y se pueden pagar en 6 cuotas fijas con tarjeta sin interés. Consulte descuentos de contado.</div>
                  <p className="mb-0 text-right"><small><strong>{totalProductos}</strong> productos encontrados</small></p>
                </div>
              </div>

              <div className="esige-productos-container px-md-4 px-md-0 pr-md-3">
                {
                  showFilters &&
                  <div className="d-none d-md-block col-md-3 mt-1">
                    <ProductosFilter
                      onChangeFilter={onChangeFilter}
                      removeCodesFromUrl={removeCodesFromUrl}
                      breadcrumbs={breadcrumbs}
                      filters={filters}
                      loading={false}
                      onShowMore={onShowMore}
                    />
                  </div>
                }
                {
                  reloading ?
                    <div className={`text-center my-5 col-xs-12 col-sm-12 ${showFilters ? "col-md-9 col-lg-9 mt-1-i" : "col-md-12 col-lg-12"}`}>
                      <Loader
                        type="Bars"
                        color="#00BFFF"
                        height={100}
                        width={100}
                        timeout={3000} //3 secs
                      />
                    </div>
                    :
                    <div className={`esige-productos-list col-xs-12 col-sm-12 ${showFilters ? "col-md-9 col-lg-9 mt-1-i" : "col-md-12 col-lg-12"}`}>
                      <div className="row">
                        {
                          productos.map(
                            (producto) => (
                              <div
                                className={`p-1 p-sm-2 p-md-3 col-6 col-sm-6 ${showFilters ? "col-md-6" : "col-md-4"} col-lg-3 col-xl-3 col-xxl-2`}
                                key={`articulo-${producto.code}`}
                              >
                                <View.ProductoBox orientation="vertical" articulo={producto} maxQuantity={999} />
                              </div>
                            )
                          )
                        }
                      </div>
                      <PageNavigation
                        cantProd={productos.length}
                        currentPage={chosenPage}
                        totalPages={totalPages}
                        OnChangeNavigationBar={OnChangeNavigationBar}
                      />
                    </div>
                }
              </div>
            </>
          )
        }
      </div>
    </>
  );
}

export default ProductosView;
